
export default {
  props: {
    headers: {}
  }
};
